import NavigationLayout from "../navigation/navigation-layout.js";
import PlatformTab from './platform-tab.js';
import FooterLayout from '../footer/footer-layout.js';
import SectionLayout from "../../layouts/section-layout.js";

const PlatformLayout = () => {
    return (
        <>
            <NavigationLayout />

            <SectionLayout children={<PlatformTab />}/>

            <FooterLayout />
        </>
    );
}

export default PlatformLayout;